import AddDepoRequest from "./AddDepoRequest";

export default class SaveDepoRequest extends AddDepoRequest {
    public id: string = "";
}